import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import { handleDownloadCSV } from "../../../../utils/CsvDownload";

const Table = ({
  TableData = [],
  setTableData = () => { },
}) => {
  const tableRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [focusedInputIndex, setFocusedInputIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = TableData.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    cols?.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

const handleAsnQtyChange = (index, value) => {
  const numericValue = Number(value);

  const updated = TableData.map((item, i) => {
    if (i === index) {
      const maxQty = item.order_qty;
      return {
        ...item,
        asn_qty: numericValue > maxQty ? maxQty : numericValue,
      };
    }
    return item;
  });

  setTableData(updated);
};

  return (
    <div>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "S.No",
              "Purchase Order",
              "Item Code",
              "Item Name",
              "UOM",
              "Order Qty",
                    "ASN Qty",
              "Already ASN Qty",
              "Remaining Qty",
        
            ].map((title, i) => (
              <th
                key={i}
                style={{
                  fontSize: "10px",
                  textAlign: "center",
                  minWidth: "50px",
                  position: "relative"
                }}
              >
                {title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="text-center">{globalIndex + 1}</td>
                <td className="text-center">{row.purchase_order}</td>
                <td className="text-center">{row.item_code}</td>
                <td className="text-center">{row.item_name}</td>
                <td className="text-center">{row.uom}</td>
                <td className="text-center">{row.order_qty}</td>
                      <td className="p-0 text-center"
                  onClick={() => setActiveIndex(globalIndex)}
                  style={
                    activeIndex === globalIndex
                      ? {
                        height: '30px',
                        borderLeft: '1.6px solid #270b79',
                        borderTop: '0.8px solid #270b79',
                        borderRight: '0.8px solid #270b79',
                        borderBottom: '0.8px solid #270b79',
                      }
                      : {}
                  }
                >
                  <input
                    type="text"
                    className="form-control tableinput noborder text-center"
                    style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center', width: '80px' }}
                    min={1}
                    value={row.asn_qty}

                    onChange={(e) => handleAsnQtyChange(globalIndex, e.target.value)}
                  />
                </td>
                <td className="text-center">{row.already_asn_qty}</td>
                <td className="text-center">{row.remaining_qty}</td>

          



              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Footer Section */}
      <div className="d-flex pb-2 justify-content-between align-items-center">
        {/* <div className="d-flex" style={{ gap: '4px' }}>
          {TableData.length > 0 && (
            <Button
              className="createbtn d-flex"
              style={{ gap: '2px', height: '28px' }}
              iconName="MdOutlineFileDownload"
              iconSize={12}
              onClick={() => {
                handleDownloadCSV(
                  [
                    "S.No",
                    "Item Code",
                    "Item Name",
                    "UOM",
                    "Order Qty",
                    "Already ASN Qty",
                    "Remaining Qty",
                    "ASN Qty"
                  ],
                  TableData.map((row, i) => ({
                    sno: i + 1,
                    item_code: row.item_code,
                    item_name: row.item_name,
                    uom: row.uom,
                    order_qty: row.order_qty,
                    already_asn_qty: row.already_asn_qty,
                    remaining_qty: row.remaining_qty,
                    asn_qty: row.asn_qty
                  })),
                  "asn-data"
                );
              }}
            >
              Download
            </Button>
          )}
        </div> */}

        {/* Pagination */}
        <div
          className={`${TableData.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`}
          style={{ gap: '5px' }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={TableData.length}
          />
        </div>

        <div className={`${TableData.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, TableData.length)} of {TableData.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default Table;
